$(document).ready(function() {
    
    $("a.fancybox").fancybox({'overlayShow':    true});

	$('a#tire_size_go_2').click(function(e) {
    	e.preventDefault();
		$('form#tire_select_form_2').submit();
	});
    
	$('form#tire_select_form_2').submit(function(e) {
			
		e.preventDefault();
		
		var model_no = $("input#model_no_2").val();
		// console.log(model_no);
		
		// create query
		var new_url = "https://tireballs.myshopify.com/";
		var query_string = "search?q=";

		if (model_no.length > 0) {
			query_string = query_string + model_no;
		}
		new_url = new_url + query_string;
		// console.log(new_url);
		
		if ( model_no.length > 0) {
			window.location = new_url;
		};
		
		return false;
						
	});
	
    $('.slideshow').cycle({
        fx: 'fade',
        timeout: 4000
    });
	

});
